module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"email":"E-Mail","login":"Login","oauth":"Login with {title}","password":"Password"}}')
  delete Component.options._Ctor
}
